var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('z-caption',{staticClass:"innovation-title",class:_vm.classObject,attrs:{"decor-right":"","tag":"h2","size":"3xl","weight":"600"}},[_c('span',[_vm._v(_vm._s(_vm.text))])])}
var staticRenderFns = []

export { render, staticRenderFns }